import { useCallback, useState } from "react";

// The "Deregister patient" dialog.
export const useDeregister = () => {
  const [isDeregisterDialogOpen, setIsDeregisterDialogOpen] = useState(false);

  const openDeregister = useCallback(() => setIsDeregisterDialogOpen(true), []);
  const closeDeregister = useCallback(
    () => setIsDeregisterDialogOpen(false),
    []
  );

  return { isDeregisterDialogOpen, openDeregister, closeDeregister };
};
